<template>
  <b-modal
    id="zamkniecie-wizyty"
    v-model="widoczne"
    :title="tytul"
    size="xl"
    hide-footer
    @hide="naUkrycie"
  >
    <!-- Jacek 23.10.2026: okno ZAWSZE da się zamknąć (X, Esc, tło) — lekarze nie rozumieją zastawki.
         Zamknięcie przy blokadzie = „odłóż na dziś” w medapi: wizyty wracają jutro, zapis nowej wizyty przechodzi. -->
    <div v-if="blokuje" class="small text-muted mb-2">
      Możesz zamknąć to okno krzyżykiem — zaległe wizyty wrócą jutro. Opisanie ich teraz zajmuje chwilę i jest potrzebne do rozliczeń.
    </div>
    <b-row v-if="biezaca">
      <!-- LISTA: wszystkie nieopisane wizyty, każda z polami odhaczonymi (✓) i brakującymi (○).
           Kliknięcie otwiera wizytę po prawej; kolejność dowolna (decyzja Jacka 05.10.2026). -->
      <b-col md="4" class="mb-3">
        <div class="small text-muted mb-2">Do opisania: {{ pozostalo }}</div>
        <b-list-group class="zw-lista">
          <b-list-group-item
            v-for="z in zalegle"
            :key="z.pw_id"
            button
            class="py-2"
            :class="{ 'zw-wybrana': z.pw_id === biezaca.pw_id }"
            @click="wybierz(z.pw_id)"
          >
            <div class="d-flex justify-content-between align-items-baseline">
              <strong class="text-truncate">{{ z.pacjent || 'Pacjent' }}</strong>
              <span class="small text-muted text-nowrap ml-2">{{ z.start | godzina }}</span>
            </div>
            <div class="mt-1">
              <span
                v-for="p in pola(z)"
                :key="p.nazwa"
                class="zw-pole"
                :class="p.jest ? 'zw-jest' : 'zw-brak'"
              >{{ p.jest ? '✓' : '○' }} {{ p.nazwa }}</span>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>

      <!-- WYBRANA WIZYTA -->
      <b-col md="8">
        <div class="d-flex justify-content-between align-items-start mb-3">
          <p class="mb-0">
            <strong>{{ biezaca.pacjent || 'Pacjent' }}</strong>
            <span class="text-muted"> · {{ biezaca.start | godzina }}</span>
          </p>
          <b-button size="sm" variant="outline-secondary" @click="pokazOpis = !pokazOpis">
            {{ pokazOpis ? 'Ukryj wizytę' : 'Pokaż wizytę' }}
          </b-button>
        </div>

        <!-- CAŁA WIZYTA: opis lekarza (rozpoznanie, wywiad, wykonane, zalecenia, zlecone) i uwagi z rejestracji -->
        <div v-if="pokazOpis" class="zw-opis mb-3">
          <template v-if="opis || uwagi">
            <div v-if="uwagi" class="mb-2"><span class="text-muted">Uwagi z rejestracji:</span> {{ uwagi }}</div>
            <div v-if="opis">{{ opis }}</div>
            <div v-else class="text-muted">Ta wizyta nie ma opisu lekarza.</div>
          </template>
          <div v-else class="text-muted">{{ ladujeUslugi ? 'Wczytuję…' : 'Ta wizyta nie ma opisu ani uwag.' }}</div>
        </div>

        <!-- TRYB „siec” (Jacek 19.10.2026, MK i IMK): lekarz opisuje w pełni tylko wizyty SIECIOWE.
             Wizyta bez sieci dostaje JEDNO pytanie — sieć czy prywatna. „Prywatna” zamyka ją od razu
             (bez werdyktu i usług); wybór sieci odsłania pełne oznaczanie, bo rozliczenie z siecią
             potrzebuje całości. Zabezpieczenie na wypadek, gdyby wizyta sieciowa przedostała się
             jako prywatna. Tryb nadaje panel medapi per lekarz; bez wpisu okno działa jak dotąd. -->
        <template v-if="pytajNajpierwOPlatnika">
          <div class="mb-2 font-weight-bold">Kto płaci za tę wizytę?</div>
          <div class="mb-2">
            <b-button
              v-for="p in platnicy"
              :key="p.id"
              size="sm"
              class="mr-2 mb-2"
              :variant="platnik === p.id ? 'primary' : 'outline-secondary'"
              @click="wybierzPlatnika(p.id)"
            >{{ p.nazwa }}</b-button>
          </div>
          <p class="small text-muted mb-3">
            {{ tylkoZnacznik ? 'Wizyty prywatnej nie opisujesz — wystarczy ten znacznik. Przy sieci pojawią się pozostałe pytania.' : 'Wizyta sieciowa — opisz ją w całości.' }}
          </p>
        </template>

        <!-- KROK 1: czy się odbyła. Dwa przyciski, bo tylko dwie odpowiedzi
             cokolwiek znaczą dla rozliczeń; odwołanie ma własne miejsce
             (ww_rodzaj='odwolana') i nie przechodzi tędy. -->
        <div v-if="!tylkoZnacznik" class="mb-3">
          <b-button
            :variant="werdykt === 'odbyta' ? 'success' : 'outline-success'"
            class="mr-2"
            @click="wybierzWerdykt('odbyta')"
          >Odbyła się</b-button>
          <b-button
            :variant="werdykt === 'nieodbyta' ? 'danger' : 'outline-danger'"
            @click="wybierzWerdykt('nieodbyta')"
          >Nie było pacjenta</b-button>
        </div>

        <div v-if="werdykt === 'odbyta'">
          <div v-if="ladujeUslugi" class="text-muted mb-2">Wczytuję cennik…</div>
          <template v-else>
            <!-- KROK 2: kto płaci. Sieć ustawiona przy rejestracji jest zaznaczona —
                 lekarz potwierdza albo poprawia (decyzja Jacka 04.10.2026: wizyta ma
                 być oznaczona u źródła: prywatna czy sieć, czy zapłacił i jak).
                 Pytanie stoi PRZED „co wykonano”, bo lista procedur idzie za płatnikiem (21.10.2026).
                 W trybie „siec” to pytanie stoi już na górze okna. -->
            <div v-if="!pytajNajpierwOPlatnika" class="mb-2 font-weight-bold">Kto płaci?</div>
            <div v-if="!pytajNajpierwOPlatnika" class="mb-3">
              <b-button
                v-for="p in platnicy"
                :key="p.id"
                size="sm"
                class="mr-2 mb-2"
                :variant="platnik === p.id ? 'primary' : 'outline-secondary'"
                @click="wybierzPlatnika(p.id)"
              >{{ p.nazwa }}</b-button>
            </div>

            <!-- KROK 3 (od 21.10.2026): PROCEDURY. Lekarz widzi tylko procedury uzgodnione z płatnikiem
                 wizyty — wariant usługi, cenę i swoją stawkę dobiera medapi (lekarz nie widzi kwot).
                 Placówka bez indeksu procedur dostaje dawny słownik usług (v-else niżej). -->
            <template v-if="procedury">
              <div class="mb-2 font-weight-bold">Co wykonano?</div>
              <p v-if="!platnik" class="small text-muted mb-3">Najpierw wskaż, kto płaci — lista procedur zależy od płatnika.</p>
              <div v-else-if="listaProcedur.length" class="mb-3">
                <b-button
                  v-for="p in listaProcedur"
                  :key="p.kod"
                  size="sm"
                  class="mr-2 mb-2"
                  :variant="wybrane.includes(p.kod) ? 'primary' : 'outline-secondary'"
                  @click="przelacz(p.kod)"
                >{{ p.nazwa }}</b-button>
              </div>
              <p v-else class="small text-danger mb-3">
                Z tym płatnikiem nie masz uzgodnionych procedur — sprawdź płatnika albo zgłoś to recepcji.
              </p>
              <p v-if="zejda.length" class="small text-warning mb-2">Przy zapisie zejdą z wizyty: {{ zejda.join(', ') }}</p>
              <p v-if="inne.length" class="small text-muted mb-3">Na wizycie są też: {{ inne.join(', ') }}</p>
            </template>

            <!-- KROK 3 (dawny): usługi z cennika. Domyślnie tylko usługi TEGO lekarza (cennik
                 uslu_leka_ceny); pełny cennik pod przełącznikiem, bo dropdown ze
                 wszystkim mylił (decyzja z 31.08). -->
            <template v-else>
              <div class="mb-2">
                <span class="font-weight-bold">Co wykonano?</span>
                <b-button size="sm" variant="link" @click="pelnyCennik = !pelnyCennik">
                  {{ pelnyCennik ? 'tylko moje usługi' : 'pełny cennik' }}
                </b-button>
              </div>
              <div class="mb-3">
                <b-button
                  v-for="u in widoczneUslugi"
                  :key="u.uslu_id"
                  size="sm"
                  class="mr-2 mb-2"
                  :variant="wybrane.includes(u.uslu_id) ? 'primary' : 'outline-secondary'"
                  @click="przelacz(u.uslu_id)"
                >{{ u.nazwa }}</b-button>
              </div>
            </template>

            <!-- guzki. To jest CENA (u sieci biopsja obejmuje 1–2 guzki albo każdy guzek osobno),
                 a do 22.09.2026 nie było tego gdzie zapisać. -->
            <b-form-group v-if="pytajOGuzki" label="Ile guzków nakłuto?">
              <b-form-input
                v-model="guzki"
                type="number"
                :min="procedury ? 1 : 0"
                max="20"
                style="max-width: 8rem"
              />
            </b-form-group>

            <!-- KROK 4: sposób zapłaty — zawsze, gdy płaci pacjent -->
            <div v-if="pytajOZaplate">
              <div class="mb-2">
                <span class="font-weight-bold">Sposób zapłaty</span>
                <span v-if="kwota > 0" class="text-muted"> · {{ kwota }} zł wg cennika</span>
              </div>
              <div class="mb-3">
                <b-button
                  v-for="p in platnosci"
                  :key="p.id"
                  size="sm"
                  class="mr-2 mb-2"
                  :variant="platnosc === p.id ? (p.id === 'niezaplacone' ? 'warning' : 'primary') : 'outline-secondary'"
                  @click="platnosc = p.id"
                >{{ p.nazwa }}</b-button>
              </div>
            </div>
          </template>
        </div>

        <div v-if="blad" class="text-danger mb-2">{{ blad }}</div>

        <div class="d-flex justify-content-between align-items-center">
          <span class="text-muted small">
            <template v-if="!blokuje">dziś jeszcze nie blokuje</template>
          </span>
          <div>
            <b-button variant="link" class="mr-2" :disabled="odkladam" @click="odlozNaDzis">
              {{ odkladam ? 'Odkładam…' : blokuje ? 'Zamknij na dziś — opiszę później' : 'Zamknę później' }}
            </b-button>
            <b-button variant="primary" :disabled="!gotowe || zapisuje" @click="zapisz">
              {{ zapisuje ? 'Zapisuję…' : pozostalo > 1 ? 'Zapisz i następna' : 'Zapisz' }}
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import zamkniecie from '../services/zamkniecie'
import moment from 'moment'

/**
 * OKNO ZAMKNIĘCIA WIZYTY — wymusza dane, których rozliczenia nie mają skąd wziąć.
 *
 * Zmierzone przed wdrożeniem (gabinet2, wizyty po terminie): usługi ma 10% wizyt,
 * a wszystkie 1410 biopsji wisi jako „zaplanowana". Dlatego pytamy przy następnej
 * wizycie, gdy lekarz jeszcze pamięta, a nie w arkuszu na koniec miesiąca.
 *
 * Układ (05.10.2026): po lewej LISTA nieopisanych wizyt z polami odhaczonymi i
 * brakującymi, po prawej wybrana wizyta — pytania i, na żądanie, cały jej opis.
 * Lekarz przechodzi wizyty w dowolnej kolejności; zapis przenosi do następnej.
 *
 * Od 23.10.2026 okno jest ZAWSZE zamykalne (decyzja Jacka: lekarze nie rozumieją zastawki). Zamknięcie przy
 * blokadzie (X, Esc, tło, przycisk) odkłada strażnika tego lekarza w medapi do końca dnia — zaległe wracają jutro.
 */
export default {
  name: 'ZamkniecieWizyty',
  filters: {
    godzina(v) {
      return v ? moment(String(v).replace(' ', 'T')).format('DD.MM HH:mm') : ''
    }
  },
  data() {
    return {
      widoczne: false,
      blokuje: false,
      // true = okno otworzyła blokada (wejście w wizytę albo 409 przy zapisie); false = lekarz z belki „Do opisania”
      zBlokady: false,
      // tryb opisywania TEGO lekarza z medapi: 'pelny' (jak dotąd) albo 'siec' (prywatna = jeden znacznik)
      tryb: 'pelny',
      zalegle: [],
      // pw_id wizyty wybranej z listy; null = pierwsza z listy
      wybranaId: null,
      werdykt: null,
      wizyta: null,
      opis: '',
      uwagi: '',
      pokazOpis: false,
      slownik: [],
      // tryb procedur (21.10.2026): { prywatna: [...], luxmed: [...] } z medapi; null = dawny słownik usług
      procedury: null,
      // pozycje wizyty spoza indeksu procedur — tylko do wglądu
      inne: [],
      // kody procedur, które wizyta ma przed zapisem
      naWizycie: [],
      // zaznaczone: kody procedur (tryb procedur) albo uslu_id (dawny słownik)
      wybrane: [],
      guzki: '',
      // kto płaci: 'pacjent' albo slug sieci (te same co w medapi); null = jeszcze nie wybrano
      platnik: null,
      // jak pacjent zapłacił: gotowka | karta | przelew | niezaplacone
      platnosc: null,
      platnicy: [
        { id: 'pacjent', nazwa: 'Pacjent (prywatnie)' },
        { id: 'luxmed', nazwa: 'LUX MED' },
        { id: 'enelmed', nazwa: 'Enel-Med' },
        { id: 'compensa', nazwa: 'Compensa' },
        { id: 'inter', nazwa: 'Inter' },
        { id: 'gaj', nazwa: 'Gaj' }
      ],
      platnosci: [
        { id: 'gotowka', nazwa: 'Gotówka' },
        { id: 'karta', nazwa: 'Karta' },
        { id: 'przelew', nazwa: 'Przelew' },
        { id: 'niezaplacone', nazwa: 'Nie zapłacił' },
        { id: 'bezplatna', nazwa: 'Bez opłaty' }
      ],
      pelnyCennik: false,
      ladujeUslugi: false,
      zapisuje: false,
      // trwa „odłóż na dziś” (X przy blokadzie) — żeby nie wysłać dwa razy
      odkladam: false,
      blad: ''
    }
  },
  watch: {
    // ekran wizyty pokazuje belkę „Do opisania: N” — dostaje liczbę przy każdej zmianie listy
    zalegle(lista) {
      this.$emit('stan', { ile: lista.length, blokuje: this.blokuje })
    }
  },
  computed: {
    /**
     * O liczbę guzków pytamy przy karcie biopsji ALBO gdy zaznaczono usługę biopsji (20.10.2026): liczba guzków
     * tworzy pozycje 2..n w rozliczeniu z siecią (medapi lib/rozliczenia/biopsja.ts); brak karty zakłada medapi.
     */
    pytajOGuzki() {
      // tryb procedur: o guzki pyta tylko zaznaczona procedura z parametrem (BIO-02) — guzki to jej ilość
      if (this.procedury) return this.wybraneProcedury.some((p) => p.parametr === 'guzki')
      if (this.wizyta && this.wizyta.fakt_biopsja) return true
      return this.slownik.some((u) => this.wybrane.includes(u.uslu_id) && /biops/i.test(String(u.nazwa || '')))
    },
    /** procedury uzgodnione z wybranym płatnikiem; „pacjent” = cennik prywatny */
    listaProcedur() {
      if (!this.procedury || !this.platnik) return []
      return this.procedury[this.platnik === 'pacjent' ? 'prywatna' : this.platnik] || []
    },
    /** zaznaczone i obecne na liście płatnika — zmiana płatnika gasi procedury spoza jego umowy */
    wybraneProcedury() {
      return this.listaProcedur.filter((p) => this.wybrane.includes(p.kod))
    },
    /** procedury, które wizyta już ma, a zapis je zdejmie (odznaczone albo spoza umowy płatnika) — medapi: lista to komplet */
    zejda() {
      if (!this.procedury || !this.platnik) return []
      const nazwa = (kod) => Object.values(this.procedury).flat().find((p) => p.kod === kod)
      return this.naWizycie
        .filter((kod) => !this.wybraneProcedury.some((p) => p.kod === kod))
        .map((kod) => (nazwa(kod) || { nazwa: kod }).nazwa)
    },
    biezaca() {
      return this.zalegle.find((z) => z.pw_id === this.wybranaId) || this.zalegle[0] || null
    },
    pozostalo() {
      return this.zalegle.length
    },
    tytul() {
      return this.blokuje ? 'Opisz zaległe wizyty' : 'Wizyty czekają na opis'
    },
    widoczneUslugi() {
      const moje = this.slownik.filter((u) => u.dla_lekarza)
      return this.pelnyCennik || moje.length === 0 ? this.slownik : moje
    },
    /** suma zaznaczonych usług wg cennika z dnia wizyty — czy jest za co płacić */
    kwota() {
      return this.slownik
        .filter((u) => this.wybrane.includes(u.uslu_id))
        .reduce((s, u) => s + Number(u.cena || 0), 0)
    },
    /**
     * O sposób zapłaty pytamy ZAWSZE, gdy płaci pacjent (05.10.2026). Wcześniej tylko przy kwocie > 0, a usługi
     * z cennika sieci mają cenę 0 — wybrane u pacjenta prywatnego chowały pytanie. Wizyta darmowa = „Bez opłaty".
     */
    pytajOZaplate() {
      return this.platnik === 'pacjent'
    },
    /** tryb „siec” i wizyta bez sieci z rejestracji: pytanie o płatnika idzie PIERWSZE */
    pytajNajpierwOPlatnika() {
      return this.tryb === 'siec' && !!this.biezaca && !(this.biezaca.stan && this.biezaca.stan.siec)
    },
    /** …a dopóki lekarz nie wskazał sieci, znacznik jest WSZYSTKIM, czego od tej wizyty chcemy */
    tylkoZnacznik() {
      return this.pytajNajpierwOPlatnika && (!this.platnik || this.platnik === 'pacjent')
    },
    gotowe() {
      if (this.tylkoZnacznik) return this.platnik === 'pacjent'
      if (this.werdykt === 'nieodbyta') return true
      if (this.werdykt !== 'odbyta') return false
      if ((this.procedury ? this.wybraneProcedury : this.wybrane).length === 0) return false
      if (this.pytajOGuzki && String(this.guzki).trim() === '') return false
      if (this.procedury && this.pytajOGuzki && !(Number(this.guzki) >= 1)) return false
      if (!this.platnik) return false
      if (this.pytajOZaplate && !this.platnosc) return false
      return true
    }
  },
  methods: {
    /** pola wizyty na liście: co już jest (✓), czego brakuje (○); pola niedotyczące wizyty pomijamy */
    pola(z) {
      const s = z.stan
      // medapi sprzed 05.10 nie zwraca stanu — pokazujemy pierwsze brakujące pole
      if (!s) return [{ nazwa: z.brakuje, jest: false }]
      // tryb „siec”: wizyta bez sieci ma jedno pole — znacznik (zapłata z dawnego okna też się liczy)
      if (this.tryb === 'siec' && !s.siec) return [{ nazwa: 'sieć / prywatna', jest: !!s.platnik || !!s.platnosc }]
      if (s.werdykt === 'nieodbyta') return [{ nazwa: 'nie było pacjenta', jest: true }]
      const p = [
        { nazwa: 'odbyła się', jest: s.werdykt === 'odbyta' },
        { nazwa: 'usługi', jest: !!s.uslugi }
      ]
      if (s.guzki !== null && s.guzki !== undefined) p.push({ nazwa: 'guzki', jest: !!s.guzki })
      p.push({ nazwa: 'kto płaci', jest: !!s.siec || !!s.platnosc })
      // sposób zapłaty dotyczy każdej wizyty, za którą płaci pacjent
      if (!s.siec) p.push({ nazwa: 'zapłata', jest: !!s.platnosc })
      return p
    },
    wybierz(pwId) {
      if (this.zapisuje || (this.biezaca && this.biezaca.pw_id === pwId)) return
      this.wybranaId = pwId
      this.wczytajUslugi()
    },
    /** pyta serwer i pokazuje okno, gdy jest co opisać; zwraca true, gdy blokuje */
    async sprawdz() {
      try {
        const { data } = await zamkniecie.zalegle()
        this.blokuje = !!data.blokuje
        this.tryb = data.tryb || 'pelny'
        this.zalegle = data.zalegle || []
        // ŁAGODNY STRAŻNIK (20.10.2026): okno wyskakuje samo TYLKO przy blokadzie (zaległości sprzed poprzedniego
        // dnia roboczego). Świeże zaległości pokazuje belka „Do opisania” w wizycie — lekarz otwiera okno, kiedy chce.
        if (this.zalegle.length > 0 && this.blokuje) {
          this.zBlokady = true
          this.widoczne = true
          await this.wczytajUslugi()
        }
        return this.blokuje && this.zalegle.length > 0
      } catch (e) {
        // awaria strażnika nie może zatrzymać przyjmowania pacjentów
        return false
      }
    },
    /**
     * Zamknięcie okna przy blokadzie (X, Esc, tło): nie puszczamy od razu — najpierw medapi odkłada strażnika na dziś,
     * inaczej zapis wizyty zaraz odbiłby się o 409 i okno wróciłoby „samo z siebie”.
     */
    naUkrycie(e) {
      if (!this.blokuje || this.odkladam) return
      if (e && e.preventDefault) e.preventDefault()
      this.odlozNaDzis()
    },
    async odlozNaDzis() {
      if (!this.blokuje) {
        this.widoczne = false
        return
      }
      if (this.odkladam) return
      this.odkladam = true
      this.blad = ''
      try {
        await zamkniecie.odloz()
        this.blokuje = false
        this.$emit('stan', { ile: this.zalegle.length, blokuje: false })
        this.widoczne = false
        // strażnik odłożony — ekran wizyty dokańcza zapis wstrzymany przez 409
        this.$emit('zamkniete')
      } catch (err) {
        this.blad = 'Nie udało się odłożyć na dziś — spróbuj jeszcze raz albo opisz wizyty.'
      } finally {
        this.odkladam = false
      }
    },
    /** lekarz sam otwiera okno z belki „Do opisania” (bez blokady) */
    async otworz() {
      this.zBlokady = false
      this.widoczne = this.zalegle.length > 0
      if (this.widoczne) await this.wczytajUslugi()
    },
    /** to samo okno, gdy zapis wizyty odbił się o 409 z serwera */
    pokazZOdpowiedzi(zalegle, tryb) {
      this.zBlokady = true
      this.blokuje = true
      if (tryb) this.tryb = tryb
      this.zalegle = zalegle || []
      this.widoczne = this.zalegle.length > 0
      if (this.widoczne) this.wczytajUslugi()
    },
    async wczytajUslugi() {
      if (!this.biezaca) return
      const pwId = this.biezaca.pw_id
      this.ladujeUslugi = true
      this.werdykt = null
      this.wybrane = []
      this.guzki = ''
      this.platnik = null
      this.platnosc = null
      this.opis = ''
      this.uwagi = ''
      this.blad = ''
      try {
        const { data } = await zamkniecie.uslugi(pwId)
        // lekarz zdążył kliknąć inną wizytę — odpowiedź dla poprzedniej porzucamy
        if (!this.biezaca || this.biezaca.pw_id !== pwId) return
        this.wizyta = data.wizyta || null
        this.slownik = data.slownik || []
        this.procedury = data.procedury || null
        this.inne = data.inne || []
        this.opis = data.opis || ''
        this.uwagi = (data.wizyta && data.wizyta.uwagi) || ''
        // pozycje dopisane wcześniej (np. przez recepcję) zaznaczamy — lekarz
        // ma potwierdzić, a nie wpisywać drugi raz
        if (this.procedury) {
          this.naWizycie = (data.wybrane || []).map((p) => p.kod)
          this.wybrane = this.naWizycie.slice()
          // liczba guzków tylko, gdy już zapisana — pustego pola nie zgadujemy jedynką
          const bio = (data.wybrane || []).find((p) => p.kod === 'BIO-02' && p.ilosc)
          if (bio) this.guzki = String(bio.ilosc)
        } else {
          this.wybrane = (data.pozycje || []).map((p) => p.uslu_id).filter(Boolean)
        }
        // to samo z werdyktem, siecią i zapłatą: co już jest w wizycie, jest zaznaczone.
        // Brak sieci NIE znaczy „prywatna” — lekarz ma to wybrać sam.
        const w = this.wizyta || {}
        if (w.realizacja === 'odbyta' || w.realizacja === 'nieodbyta') this.werdykt = w.realizacja
        const siec = w.platnik === 'comp' ? 'compensa' : w.platnik
        if (siec && this.platnicy.some((p) => p.id === siec)) this.platnik = siec
        if (w.platnosc && this.platnosci.some((p) => p.id === w.platnosc)) {
          this.platnik = this.platnik || 'pacjent'
          this.platnosc = w.platnosc
        }
      } catch (e) {
        this.slownik = []
        this.procedury = null
        this.inne = []
        this.naWizycie = []
      } finally {
        this.ladujeUslugi = false
      }
    },
    wybierzWerdykt(w) {
      this.werdykt = w
      this.blad = ''
    },
    wybierzPlatnika(id) {
      this.platnik = id
      if (id !== 'pacjent') this.platnosc = null
      this.blad = ''
    },
    przelacz(usluId) {
      const i = this.wybrane.indexOf(usluId)
      if (i >= 0) this.wybrane.splice(i, 1)
      else this.wybrane.push(usluId)
    },
    async zapisz() {
      if (!this.gotowe || !this.biezaca) return
      this.zapisuje = true
      this.blad = ''
      try {
        const odbyta = this.werdykt === 'odbyta'
        let dane = {
          werdykt: this.werdykt,
          uslugi: odbyta ? this.wybrane : [],
          guzki: odbyta && this.pytajOGuzki ? this.guzki : null,
          platnik: odbyta ? this.platnik : null,
          platnosc: odbyta && this.pytajOZaplate ? this.platnosc : null
        }
        if (this.procedury) {
          // procedury: kod + ilość (guzki przy biopsji); wariant usługi, cenę i stawkę dobiera medapi
          dane = {
            werdykt: this.werdykt,
            procedury: odbyta
              ? this.wybraneProcedury.map((p) => ({ kod: p.kod, ilosc: p.parametr === 'guzki' ? Number(this.guzki) : 1 }))
              : [],
            platnik: dane.platnik,
            platnosc: dane.platnosc
          }
        }
        // sam znacznik „prywatna” (tryb „siec”): bez werdyktu i usług — serwer zapisuje tylko płatnika
        if (this.tylkoZnacznik) dane = { werdykt: null, uslugi: [], guzki: null, platnik: 'pacjent', platnosc: null }
        const { data } = await zamkniecie.zamknij(this.biezaca.pw_id, dane)
        this.blokuje = !!data.blokuje
        this.tryb = data.tryb || this.tryb
        this.zalegle = data.zalegle || []
        // okno otwarte przez blokadę zamyka się, gdy blokada zeszła — świeże zaległości zostają na belce,
        // a zapis wizyty, który odbił się o 409, idzie dalej (AddVisit: poZamknieciuPoprzedniej)
        if (this.zalegle.length === 0 || (this.zBlokady && !this.blokuje)) {
          this.widoczne = false
          this.$emit('zamkniete')
        } else {
          // zapisana wizyta zeszła z listy → `biezaca` wskazuje pierwszą z pozostałych
          await this.wczytajUslugi()
        }
      } catch (e) {
        const odp = e.response && e.response.data
        this.blad = (odp && (odp.message || odp.error || odp.opis)) || 'Nie udało się zapisać — spróbuj jeszcze raz.'
      } finally {
        this.zapisuje = false
      }
    }
  }
}
</script>

<style scoped>
.zw-lista {
  max-height: 62vh;
  overflow-y: auto;
}
.zw-wybrana {
  background: #eef4ff;
  border-left: 3px solid #2f6fed;
}
.zw-pole {
  display: inline-block;
  font-size: 11px;
  line-height: 1.5;
  padding: 0 7px;
  border-radius: 10px;
  margin: 0 4px 3px 0;
  white-space: nowrap;
}
.zw-jest {
  background: #e6f4ea;
  color: #1e6b36;
}
.zw-brak {
  background: #fdecea;
  color: #a32a1c;
}
.zw-opis {
  white-space: pre-wrap;
  max-height: 38vh;
  overflow-y: auto;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 13px;
}
</style>
